import React from 'react'
import styled from 'styled-components'
import Points from './Points/Points'
import Assists from './Assists/Assists'
import Blocks from './Blocks/Blocks'




function Stats() {
  return (
    <Div>
    <Points/>
    <Assists/>
    <Blocks/>
    </Div>
  )
}

export default Stats


const Div = styled.div`
width: 100%;
display: flex;
flex-direction: column;
justify-content: center;
align-items: center;
a{
  text-decoration: none;
}
`
